import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import DocPage from "../components/DocPage.vue";
import { useLocalePath } from "../composables/useLocalePath";


export default /*#__PURE__*/_defineComponent({
  __name: 'NotFound',
  setup(__props) {

const lp = useLocalePath();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(DocPage, {
    title: _ctx.$t('pages.notfound.title'),
    lede: _ctx.$t('pages.notfound.lede')
  }, {
    default: _withCtx(() => [
      _createElementVNode("p", null, [
        _createVNode(_component_router_link, {
          to: _unref(lp)('/')
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("pages.notfound.home")), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("p", null, [
        _createVNode(_component_router_link, {
          to: _unref(lp)('/connectera')
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("pages.notfound.connectera")), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ]),
    _: 1
  }, 8, ["title", "lede"]))
}
}

})